module.exports = require('lodash').isElement